import type { GridInterface } from '@ad-lucy/context/adData';

import { defineGrid } from './defineGrid';

export const grid1I2 = (): GridInterface[] =>
  defineGrid(
    '1|2',
    [
      {
        name: 'Sitebar',
        rows: [
          {
            columns: [
              {
                tileId: 0,
                spanRow: 2,
              },
              {
                tileId: 1,
              },
            ],
          },
          {
            columns: [
              {
                tileId: 2,
              },
              {
                tileId: 3,
              },
            ],
          },
        ],
      },
    ],
    2,
    2,
  );
